import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { usePrivy } from "@privy-io/react-auth";
import { logout, changePage } from "../../store/actions";
import defaultUserIcon from "../../images/is-icon.png";
import useConnectedWallet from "../../hooks/useConnectedWallet";
import performLogout from "../../utils/performLogout";

const DropDown = ({ isOpen, toggleIsOpen, userIcon }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { logout: privyLogout } = usePrivy();
  const { address, isConnected } = useConnectedWallet();
  const partnerEmail = useSelector(
    (state) => state.userReducer.user.response.email
  );
  const partnerPublicName = useSelector(
    (state) => state.userReducer.user.response.partnerPublicName
  );
  const partnerName = useSelector(
    (state) => state.userReducer.user.response.partnerName
  );

  const handleLogout = () => performLogout({ privyLogout, dispatch, logout });

  const handleChangePage = (value) => {
    dispatch(changePage(value));
  };

  const displayName = partnerPublicName || partnerName;

  return (
    <div className="isw-usermenu-wrap">
      <button type="button" className="isw-chip" onClick={toggleIsOpen}>
        <span className="av">
          {userIcon ? <img src={userIcon} alt="user-avatar" /> : null}
        </span>
        <span style={{ maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis" }}>
          {displayName}
        </span>
        <span className="caret">▾</span>
      </button>

      {isOpen && (
        <div className="isw-usermenu">
          <div className="who">
            <div className="n">{displayName}</div>
            {partnerEmail && partnerEmail !== "notProvided" && (
              <div className="e">{partnerEmail}</div>
            )}
          </div>

          {isConnected && address && (
            <button
              type="button"
              className="mi"
              onClick={() => {
                toggleIsOpen();
                handleChangePage("linked-wallets");
                navigate("/linked-wallets");
              }}
            >
              {address.slice(0, 6)}...{address.slice(-4)}
            </button>
          )}

          <Link
            className="mi"
            to="/account"
            onClick={() => {
              handleChangePage("account");
              toggleIsOpen();
            }}
          >
            Account
          </Link>
          <Link
            className="mi"
            to="/linked-wallets"
            onClick={() => {
              handleChangePage("linked-wallets");
              toggleIsOpen();
            }}
          >
            Linked Wallets
          </Link>
          <Link
            className="mi"
            to="/whitelisted-ips"
            onClick={() => {
              handleChangePage("whitelisted-ips");
              toggleIsOpen();
            }}
          >
            Whitelisted API IPs
          </Link>
          <Link
            className="mi"
            to="/whitelisted-websites"
            onClick={() => {
              handleChangePage("whitelisted-websites");
              toggleIsOpen();
            }}
          >
            Whitelisted Widget URLs
          </Link>
          <Link
            className="mi"
            to="/security"
            onClick={() => {
              handleChangePage("security");
              toggleIsOpen();
            }}
          >
            Security
          </Link>
          <button type="button" className="mi danger" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default DropDown;
